import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "amfe-flexible";
// 引入e-charts 全局使用
import * as echarts from "echarts";
// 引用ant组件
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
const app = createApp(App).use(store).use(router).use(Antd);
app.config.globalProperties.$echarts = echarts;
// 设置全局默认的defaultImageUrl
app.config.globalProperties.defaultImageUrl = 'https://img0.baidu.com/it/u=2677155602,1740980177&fm=253&fmt=auto&app=138&f=JPEG?w=822&h=500';

app.mount('#app');